const BaseURL = process.env.REACT_APP_API_BASE_URL || "https://iso-api-dev.up.railway.app/";

const Endpoint = {
  auth: {
    login: "/admin/login",
  },
  blog: {
    getBlogs: "/blogs",
    createBlog: "/admin/blogs",
    updateBlog: "/admin/blogs/:id",
    deleteBlog: "/admin/blogs/:id",
  },
  image: {
    getImages: "/dashboard-images",
    addImage: "/admin/dashboard-image",
    deleteImage: "/admin/dashboard-image",
    updateImage: "/admin/dashboard-image",
  },
  advertisement: {
    getAdvertisement: "/advertisement",
    addAdvertisement: "/admin/advertisement",
    updateAdvertisement: "/admin/advertisement",
    deleteAdvertisement: "/admin/advertisement",
  },
  policy: {
    createPolicy: "/admin/policy",
    getPolicy: "/policy",
    updatePolicy: "/admin/policy",
  },
  testimonials: {
    createTestimonialAnonymous: "/admin/testimonial/anonymous",
    updateTestimonialAnonymous: "/admin/testimonial/anonymous",
    getTestimonials: "/testimonial",
    deleteTestimonial: "/admin/testimonial",
  },
  registrationRequests: {
    getRegistrationRequests: "/admin/registration-requests",
    verifyRegistration: "/admin/verify-registration",
    verifyPowerSeller: "/admin/verify-powerselling",
  },
  powerSellerRequests: {
    getPowerSellerRequests: "/admin/powerseller-requests",
    verifyPowerSeller: "/admin/verify-powerselling",
  },
  products: {
    get: "/admin/get-products",
    suspend: "admin/suspend-product/:id",
    unsuspend: "admin/unsuspend-product/:id",
  },
  productBrands: {
    getBrands: "/product/get-product-makes",
    getBrandByCategory: "/product/get-product-makes-by-category",
    getCategories: "/product/get-product-categories",
    createBrand: "/admin/product/make",
    updateBrand: "/admin/product/make/:id",
    deleteBrand: "/admin/product/make/:id",
  },
  users: {
    getUsers: "/admin/get-all-users",
    suspend: "admin/suspend-user/:id",
    unsuspend: "admin/unsuspend-user/:id",
    flag: "admin/flag-user/:id",
    unflag: "admin/unflag-user/:id",
  },
  faqs: {
    addFaqSection: "/admin/faq-section",
    addFaqQuestion: "/admin/question",
    deleteFaqSection: "/admin/faq-section",
    deleteFaqQuestion: "/admin/question",
    updateFaqSection: "/admin/faq-section",
    updateFaqQuestion: "/admin/question",
    getAllSections: "/faq",
    getSectionQuestions: "/faq",
  },
  settings: {
    updateProfile: "/admin/update-profile",
    updatePassword: "/admin/change-password",
  },
  dashboard: {
    getStats: "/admin/stats",
    getNewUsers: "/admin/latest-users",
  },
  transactions: {
    getAll: "/admin/transactions",
    payout: "/admin/payout-transaction/:id",
  },
  support: {
    get: "/admin/support-message",
    delete: "/admin/support-message/:id",
  },
  reports: {
    user: {
      get: "/admin/user-report",
      delete: "/admin/user-report/:id",
    },
    product: {
      get: "/admin/product-report",
      delete: "/admin/product-report/:id",
    },
  },
};

export { Endpoint, BaseURL };
